export default "__VITE_ASSET__38270251__"